import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { getAppConfig } from "app/app.config";
import { AppComponent } from "./app/app.component";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

getAppConfig().then((config) => {
  bootstrapApplication(AppComponent, config).catch((err) =>
    // eslint-disable-next-line no-console
    console.error("Bootstrap error:", err),
  );
});
